// "Logging as Spencer Moore (Sales), helping Troy. Troy will see this entry."
// Every app user can log (decision 6); the audit trail is the control, so the
// window says out loud whose name goes on the entry when it is not the AM's.

import { useAuth } from '../../../shared/auth';

const ROLE_WORDS: Record<string, string> = {
  sales: 'Sales',
  account_manager: 'Account manager',
  national_am: 'National account manager',
  executive: 'Executive',
  superuser: 'Admin',
  finance: 'Finance',
  hr: 'HR',
};

export function roleWord(role: string | null | undefined): string {
  return (role && ROLE_WORDS[role]) || 'TCS';
}

export function LoggingAs({ amEid, amName }: { amEid: string | null; amName: string | null }) {
  const { employee, profile } = useAuth();
  if (!employee) return null;
  const me = [employee.employee_name_first, employee.employee_name_last].filter(Boolean).join(' ').trim() || employee.employee_id;
  if (amEid && employee.employee_id === amEid) return null;
  const first = amName?.split(' ')[0] ?? null;
  return (
    <p className="rounded border border-st-info-border bg-st-info-bg px-3 py-2 text-xs text-st-info-fg">
      Logging as {me} ({roleWord(profile?.role)})
      {first ? `, helping ${first}. ${first} will see this entry.` : '. This clinic has no account manager on file.'}
    </p>
  );
}
